module.exports = __webpack_public_path__ + "img/notfound-icon.34d73702.png";